import { useMemo } from 'react';
import { useSellerLabelProviders } from './use-seller-label-providers';

export const useSellerLabelProvider = (sellerLabelProviderId) => {
  const sellerLabelProviders = useSellerLabelProviders();

  const sellerLabelProviderIdString = `${sellerLabelProviderId}`;

  return useMemo(() => {
    return sellerLabelProviders.find((sellerLabelProvider) => {
      return sellerLabelProvider.sellerLabelProviderId === sellerLabelProviderIdString;
    });
  }, [sellerLabelProviders, sellerLabelProviderIdString]);
};
